import Model, { attr } from '@ember-data/model';

export default class AdaptActivationModel extends Model {
  @attr('string') status!: 'on' | 'rejected';
  @attr('date') createdAt!: Date;
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'adapt-activation': AdaptActivationModel;
  }
}
